import { red } from "@material-ui/core/colors";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { ConnectedRouter } from "connected-react-router";
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";

import App from "./App/App";
import "./index.css";
import configureStore, { history } from "./redux/store";

const store = configureStore();

const theme = createTheme({
	palette: {
		primary: {
			main: "#fec823",
		},
		secondary: {
			main: "#9e0201",
		},
		error: {
			main: red[400],
		},
	},
});

// ReactDOM.render(
// 	<Provider store={store}>
// 		<ConnectedRouter history={history}>
// 			<ThemeProvider theme={theme} children={<App />} />
// 		</ConnectedRouter>
// 	</Provider>,
// 	document.getElementById("root")
// );
render(
	<Provider store={store}>
		<ConnectedRouter history={history}>
			<ThemeProvider theme={theme} children={<App />} />
		</ConnectedRouter>
	</Provider>,
	document.getElementById("root")
);
